export default "__VITE_ASSET__BiTNRbU9__"